export enum AppleWalletType {
    GIFT = 1,
    LOYALTY = 2,
    ORDER = 3,
}
